__turbopack_context__.v({
  "className": "cinzel_7a7991b9-module__pTUKia__className",
  "variable": "cinzel_7a7991b9-module__pTUKia__variable",
});
